import { UserRoleType } from "../../apiConfigs/users";
import { toCapitalCase } from "../../utils/conversion";
import Modal from "../Modal";
import Select from "../Select";

type Props = {
  rolesOptions: UserRoleType[];
  onSelect: (role: UserRoleType) => void;
  visible: boolean;
  onClose: () => void;
};

export const SelectUserRole = ({
  onClose,
  visible,
  onSelect,
  rolesOptions,
}: Props) => {
  return (
    <Modal isOpen={visible} onClose={onClose} halfWidth title="Select Role">
      <Select
        options={rolesOptions?.map((r) => ({
          label: toCapitalCase(r),
          value: r,
        }))}
        placeholder="Select role"
        onSelect={(value) => onSelect(value as UserRoleType)}
      />
    </Modal>
  );
};
